import {useSelector} from "react-redux";

import {IRootState} from "../../store/store";
import {selectIsUserAuthenticated} from "../utils/select_is_user_authenticated";

export const useIsAuthenticated = (): boolean => {
    const isAuthenticated = useSelector((state: IRootState) => selectIsUserAuthenticated(state));

    return isAuthenticated;
};
import {useSelector} from "react-redux";

import {IRootState} from "../../store/store";
import {selectIsUserAuthenticated} from "../utils/select_is_user_authenticated";

export const useIsAuthenticated = (): boolean => {
    const isAuthenticated = useSelector((state: IRootState) => selectIsUserAuthenticated(state));

    return isAuthenticated;
};
